import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { _noop } from '@client/new/helpers/general';

export const DeleteContentModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Delete?"
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Delete',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Cancel',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        Are you sure you want to delete this content?
      </Typography>
    </Modal>
  );
};
